module.exports = __webpack_public_path__ + "static/media/xmas-tree-news.6950c4d4.jpg";